export const SHIPPER_SERVICE_KEY_SEPARATOR = '||';

export interface ShipperServiceCompositeFilterConfig {
    shipperColumn: string;
    serviceCodeColumn: string;
}

export const SHIPPER_SERVICE_COMPOSITE_FILTERS = {
    SHIPPER_SERVICE: { shipperColumn: 'SHIPPER', serviceCodeColumn: 'SHIPPER_SERVICE_CODE' },
    ORDER_SHIPPER_SERVICE: { shipperColumn: 'ORDER_SHIPPER', serviceCodeColumn: 'ORDER_SHIPPER_SERVICE_CODE' }
} as const satisfies Record<string, ShipperServiceCompositeFilterConfig>;

export type ShipperServiceCompositeColumn = keyof typeof SHIPPER_SERVICE_COMPOSITE_FILTERS;

export function isShipperServiceCompositeColumn(column: string): column is ShipperServiceCompositeColumn {
    return Object.prototype.hasOwnProperty.call(SHIPPER_SERVICE_COMPOSITE_FILTERS, column);
}

export function buildShipperServiceKey(shipperCode: string, serviceCode: string): string {
    return `${shipperCode}${SHIPPER_SERVICE_KEY_SEPARATOR}${serviceCode}`;
}

export function parseShipperServiceKey(key: string): { shipperCode: string; serviceCode: string } | null {
    if (typeof key !== 'string') {
        return null;
    }
    const idx = key.indexOf(SHIPPER_SERVICE_KEY_SEPARATOR);
    if (idx < 0) {
        return null;
    }
    const shipperCode = key.slice(0, idx);
    const serviceCode = key.slice(idx + SHIPPER_SERVICE_KEY_SEPARATOR.length);
    if (!shipperCode || !serviceCode) {
        return null;
    }
    return { shipperCode, serviceCode };
}
